@if (!hideHeader) {
  <section>
    <div class="table-header-container">
      <form novalidate autocomplete="off" [formGroup]="formGroup" class="flex flex-row items-center">
        @if (!hideSearch) {
          <mat-form-field color="accent" appearance="fill">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput formControlName="value" autocomplete="off" />
            @if (state.textFilter) {
              <mat-icon matSuffix class="cursor-pointer" (click)="onTextFilterReset()"
                >delete_outline</mat-icon
                >
              }
            </mat-form-field>
          }
          @if (showRefresh) {
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="flex flex-col justify-center items-center">
              <mat-icon>manage_search</mat-icon>
            </button>
          }
        </form>
        <form
          novalidate
          autocomplete="off"
          [formGroup]="filterFormGroup"
          [ngClass]="!(filterColumns && filterColumns.length > 0) ? 'hideFilter' : 'showFilters'">
          <mat-menu #menu="matMenu" class="menu-form-wrapper" [overlapTrigger]="false">
            <div style="padding: 10px; text-align: center">
              <mat-form-field
                color="accent"
                class="full-width"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
                <mat-label>Field</mat-label>
                <mat-select formControlName="filterField" (selectionChange)="onFilterFieldChange($event)">
                  @for (filterColumn of filterColumns; track filterColumn) {
                    <mat-option [value]="filterColumn">
                      {{ filterColumn.title }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field color="accent" class="full-width">
                <mat-label>Condition</mat-label>
                <mat-select formControlName="filterComparator">
                  @for (comparator of comparators; track comparator) {
                    <mat-option [value]="comparator">
                      {{ comparator }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (isStringFilter() || isStringListFilter()) {
                <mat-form-field color="accent" class="full-width">
                  <mat-label>Value</mat-label>
                  <input matInput formControlName="filterValue" placeholder="Value" type="text" maxlength="50" />
                  @if (filterFormGroup.controls['filterValue'].hasError('required')) {
                    <mat-error>
                      Values is required
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (isDateTimeFilter()) {
                <mat-form-field color="accent" class="full-width">
                  <mat-label>Value</mat-label>
                  <input matInput formControlName="filterValue" placeholder="Value" datetime="yyyy-MM-dd HH:mm" type="date" />
                  @if (filterFormGroup.controls['filterValue'].hasError('required')) {
                    <mat-error>
                      Values is required
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (isIntFilter() || isDecimalFilter()) {
                <mat-form-field color="accent" class="full-width">
                  <mat-label>Value</mat-label>
                  <input
                    matInput
                    formControlName="filterValue"
                    placeholder="Value"
                    type="number"
                    min="-999999999"
                    max="999999999" />
                  @if (filterFormGroup.controls['filterValue'].hasError('min')) {
                    <mat-error>
                      The value is lower than the minimum -999999999
                    </mat-error>
                  }
                  @if (filterFormGroup.controls['filterValue'].hasError('max')) {
                    <mat-error>
                      The value is greater than the maximum 999999999
                    </mat-error>
                  }
                </mat-form-field>
              }
              <button mat-raised-button color="primary" (click)="onAddFilter()">Add filter</button>
            </div>
          </mat-menu>
          <span flex></span>
        </form>
        <div class="actions">
          @if (!hideActionsButtons) {
            <ng-content select="[actions]"></ng-content>
          }
          @if (showRefresh) {
            <button mat-raised-button mat-button (click)="onRefresh()" color="refresh">
              <mat-icon>refresh</mat-icon>
            </button>
          }
        </div>
      </div>
      <div style="margin-bottom: 10px">
        @if (showChipList) {
          <mat-chip-list>
            @for (filter of state.filters; track filter) {
              <mat-chip
                [selectable]="false"
                [removable]="true"
                (removed)="onRemoveFilter(filter)">
                <span>{{ filter.title }}</span>
                <span style="margin-left: 5px; margin-right: 5px">{{ filter.operator }}</span>
                <span>{{ filter.value }}</span>
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
          </mat-chip-list>
        }
      </div>
    </section>
  }
  <div class="mat-table-container">
    <table mat-table [dataSource]="dataSource" class="full-width table-font-family striped">
      <ng-content></ng-content>

      <ng-container matColumnDef="empty">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="headers.length" class="text-center not-found-row">
          <span>No result found.</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="paginator">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="headers.length">
          <div class="flex-start">
            <mat-paginator
              [length]="state.paginator.length"
              [pageIndex]="state.paginator.pageIndex"
              [pageSize]="state.paginator.pageSize"
              [pageSizeOptions]="state.paginator.pageSizeOptions"
              showFirstLastButtons
              (page)="onPageChanged($event)">
            </mat-paginator>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headers; sticky: true"></tr>
      <tr
        mat-header-row
        *matHeaderRowDef="filters; sticky: true"
      [ngClass]="{ 'display-none': filters.length === 0 }"></tr>
      <tr mat-row *matRowDef="let row; columns: headers"></tr>
      <tr mat-footer-row *matFooterRowDef="['empty']" [ngClass]="{ 'display-none': dataSource?.length !== 0 }"></tr>
      <tr
        mat-footer-row
        *matFooterRowDef="['paginator']"
      [ngClass]="{ 'display-none': !dataSource || dataSource?.length === 0 || state.paginator.length === 0 }"></tr>
    </table>
  </div>
